import { useMemo } from "react";
import Lottie from "lottie-react";

import { parseColorToRgb, recolorLottie } from "@/components/clickSplash/recolorLottie";
import topLeftData from "@/widgets/pickemWidget/pickem/f2pV2/assets/animations/TopLeft.json";
import bottomRightData from "@/widgets/pickemWidget/pickem/f2pV2/assets/animations/BottomRight.json";
import styles from "./Popup.module.scss";

const DEFAULT_PRIMARY: [number, number, number] = [0.49, 0.322, 0.953];

const PopupCornerSparkles = () => {
  const [topLeft, bottomRight] = useMemo(() => {
    const primary =
      parseColorToRgb(
        getComputedStyle(document.documentElement).getPropertyValue("--color-primary")
      ) ?? DEFAULT_PRIMARY;
    return [recolorLottie(topLeftData, primary), recolorLottie(bottomRightData, primary)];
  }, []);

  return (
    <>
      <Lottie
        className={`${styles.cornerSparkle} ${styles.cornerSparkleTopLeft}`}
        animationData={topLeft}
        loop={false}
        autoplay
        aria-hidden="true"
      />
      <Lottie
        className={`${styles.cornerSparkle} ${styles.cornerSparkleBottomRight}`}
        animationData={bottomRight}
        loop={false}
        autoplay
        aria-hidden="true"
      />
    </>
  );
};

export default PopupCornerSparkles;
